import React from 'react'

export default function Comment(props) {
    const comment = props.comment
    return (
        <li className="comment">
        <article className="comment-body">
            <footer className="comment-meta">
                <div className="comment-author vcard">
                    <img src="/assets/img/client/1.jpg" className="avatar" alt="Blog Details" />
                    <b className="fn">{comment.username}</b>
                    <span className="says">says:</span>
                </div>
                <div className="comment-metadata">
                    <a href="#">
                        <time>April 24, 2020 at 10:59 am</time>
                    </a>
                </div>
            </footer>
            <div className="comment-content">
            <p>{comment.comment}</p>
            </div>
            <div className="reply">
                <a href="#" className="comment-reply-link">Reply</a>
            </div>
        </article>
    </li>
    )
}
